import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type ToolbarButtonProperties =
{
    title: string;
    icon: IconDefinition;
    enabled?: boolean;
    selected?: boolean;
    onClick: () => void;
}

export default function ToolbarButton({ title, icon, enabled: enabledOrUndefined, selected, onClick }: ToolbarButtonProperties)
{
    // eslint-disable-next-line no-undefined
    const enabled = enabledOrUndefined || enabledOrUndefined === undefined;
    const classNames = ['btn'];
    if (!enabled) { classNames.push('disabled'); }
    if (selected) { classNames.push('selected'); }
    const element =
    <button type="button" className={classNames.join(' ')} onClick={onClick} aria-label={title} aria-disabled={!enabled} disabled={!enabled}>
        <FontAwesomeIcon icon={icon} />
    </button>;
    return element;
}